<template>
  <v-container
    id="grid"
    fluid
    grid-list-sm
    tag="section"
  >
   <v-layout row wrap>
      <v-flex xs3>
      <img src="https://www.unsw.adfa.edu.au/sites/default/files/logo_3.png" alt="UNSW Canberra" class="logo-image">
    </v-flex>
      <v-flex xs9 text-xs-left tag="h1" class="siteHeader">Contact Us</v-flex>
      <v-flex d-flex xs12 order-xs5>
        <v-layout column text-xs-left>
          <v-flex>
            <v-card flat>
              <v-card-text>{{ lorem }}</v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card flat>
              <v-card-text>{{ lorem }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
    
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      hdr: 'UNSW@Canberra',
      lorem: `Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque 
           laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto
            beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur
             aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi
             nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, 
             adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam 
             aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam 
             corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel
             eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, 
             vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?`
    }
  }
}
</script>

<style scoped>
.logo-image { max-width:200px }
.siteHeader { font-size:200%;margin-top:10px}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue